const useRatignProps = (profileData) => {
    const ratedStrings = ['Projected', 'Inactive', 'Rated'];

    const hasVerifiedSinglesRating = profileData.singlesUtr > 0 && ratedStrings.includes(profileData.ratingStatusSingles);
    const hasUnverifiedSinglesRating = profileData.myUtrSingles > 0 && ratedStrings.includes(profileData.myUtrStatusSingles);
    const hasHistoricSinglesRating = !!profileData.historicRatings?.historicSinglesRating;
    const hasEstimatedRange = profileData.utrRange?.minUtr && profileData.utrRange?.maxUtr;
    const hasVerifiedDoublesRating = profileData.doublesUtr > 0 && ratedStrings.includes(profileData.ratingStatusDoubles);
    const hasUnverifiedDoublesRating = profileData.myUtrDoubles > 0 && ratedStrings.includes(profileData.myUtrStatusDoubles);
    const hasHistoricDoublesRating = !!profileData.historicRatings?.historicDoublesRating;

    return {
        hasVerifiedSinglesRating,
        hasUnverifiedSinglesRating,
        hasHistoricSinglesRating,
        hasEstimatedRange,
        hasVerifiedDoublesRating,
        hasUnverifiedDoublesRating,
        hasHistoricDoublesRating,
    };
};

export default useRatignProps;
